/**
 * CMVisual.js
 * 
 * Displays the visual for the CM (Color Migration) section.
 * Extracted from legacy MainRight.js logic using IlAdd active="cm".
 * Ensures correct markup and class names for CSS compatibility.
 */

export const CMVisual = ({ lower }) => {
  if (lower === "left") {
    return (<div className="il-add" lower="left" data-beta-flow="true" style={{ backgroundImage: `url("/img/cm/cm-two.jpg")`}}></div>);		
  } else if (lower === "right") {
    return (<div className="il-add" lower="right" data-beta-flow="true" style={{ backgroundImage: `url("/img/cm/cm-one.jpg")`}}></div>);		
  } else {
    // Default or "upper" case
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/cm/cm-three.jpg")`}}></div>);
  }
};
